import { useAccountTrialsByPracticeId } from '@witmetrics/data-store';
import { formatInitials } from '@witmetrics/utils/strings';
import { ChevronRightIcon, ClockIcon } from '@/icons';
import { classes, getBadgeStyle, getTrialLabel } from './utils';

export interface AccountCardProps {
  name: string;
  practiceId?: number;
  onClick: () => void;
}

export default function AccountCard({
  name,
  practiceId,
  onClick,
}: AccountCardProps) {
  const trials = useAccountTrialsByPracticeId(practiceId);
  const trialLabel = getTrialLabel(trials);

  return (
    <button type="button" className={classes.card} onClick={onClick}>
      <span className={classes.badge} style={getBadgeStyle(name)}>
        {formatInitials(name, 2)}
      </span>
      <div className={classes.info}>
        <div className={classes.name}>{name}</div>
        {trialLabel && (
          <span className={classes.trial}>
            <ClockIcon size={11} strokeWidth={2.4} />
            {trialLabel}
          </span>
        )}
      </div>
      <ChevronRightIcon className={classes.chevron} strokeWidth={2.4} />
    </button>
  );
}
